









































import Vue from 'vue';
import Lottie from '~/components/Lottie.vue';
import * as animationData from '~/assets/animations/36457-survey-checklist.json';

export default Vue.extend({
  name: 'FirstTimeDialog',
  components: {
    Lottie,
  },
  data() {
    return {
      defaultOptions: {
        animationData,
        autoplay: true,
        loop: false,
      },
      anim: null as any,
    };
  },
  mounted() {
    window.addEventListener('keyup', this.handleKeys);
  },
  destroyed() {
    window.removeEventListener('keyup', this.handleKeys);
  },
  methods: {
    handleAnimation(anim: any) {
      this.anim = anim;
    },
    play() {
      this.anim.play();
    },
    startGuide() {
      this.$root.$emit('close-dialog');
      this.$router.push((this as any).localePath('/guide/orders'));
    },
    handleKeys(e: any) {
      // arrowRight
      if (e.keyCode === 39) {
        this.startGuide();
      }
    },
  },
});
